import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { faTruckFast } from '@fortawesome/pro-solid-svg-icons/faTruckFast';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import style from './style.module.less';

const messages = defineMessages({
  unknown: {
    description: 'trackingStatusIndicator.unknown',
    defaultMessage: 'Unknown',
    id: 'ssFgx3',
  },
  shipped: {
    description: 'trackingStatusIndicator.shipped',
    defaultMessage: 'In Transit',
    id: 'BVwjY6',
  },
  delivered: {
    description: 'trackingStatusIndicator.delivered',
    defaultMessage: 'Delivered',
    id: '0K2riL',
  },
  deliveryError: {
    description: 'trackingStatusIndicator.deliveryError',
    defaultMessage: 'Delivery Exception',
    id: 'VtCvXm',
  },
});

const trackingStatusesToMessages = {
  Unknown: messages.unknown,
  Shipped: messages.shipped,
  Delivered: messages.delivered,
  DeliveryError: messages.deliveryError,
};

const trackingStatusesToIcons = {
  Unknown: faCircleQuestion,
  Shipped: faTruckFast,
  Delivered: faCheck,
  DeliveryError: faExclamationTriangle,
};

export const getTrackingStatusMessage = (status) => {
  return trackingStatusesToMessages[status] || messages.unknown;
};

/**
 * @param {object} props
 * @param {string} [props.status] - Tracking status (Unknown, Shipped, Delivered, DeliveryError)
 * @param {boolean} [props.isExternalFulfillment] - Whether this is external fulfillment
 * @returns {JSX.Element | null}
 */
export const TrackingStatusIndicator = ({ status = null, isExternalFulfillment = false }) => {
  if (!status || isExternalFulfillment) {
    return null;
  }
  const icon = trackingStatusesToIcons[status] || trackingStatusesToIcons.Unknown;
  const statusMessage = getTrackingStatusMessage(status);
  const localizedStatusMessage = <FormattedMessage {...statusMessage} />;
  return (
    <Tooltip position='bottom'>
      <TooltipContent>{localizedStatusMessage}</TooltipContent>
      <div className={style['tracking-icon-wrapper']}>
        <FontAwesomeIcon className={style['tracking-icon']} icon={icon} />
      </div>
    </Tooltip>
  );
};
